import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  link: {
    color: theme.ui.secondary,
    textDecoration: 'none',
    backgroundColor: '#fff',
    marginRight: 3,
    marginLeft: 3,
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
  container: {
    textAlign: 'center',
  },
  content: {
    height: 160,
  },
  title: {
    marginBottom: 24,
  },
}));

const ForgetPasswordMessage = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Typography variant='h4' className={classes.title}>
        Email has been sent
      </Typography>
      <Box className={classes.content}>
        <Typography variant='body2'>
          Please check your email inbox for a password recovery link. Don't
          forget to check your spam folder.
        </Typography>
      </Box>

      <Typography variant='body2'>
        Back to
        <Link to='/signin' className={classes.link}>
          Sign in
        </Link>
      </Typography>
    </Box>
  );
};

export default ForgetPasswordMessage;
